import {Constants} from '../../models/constants/marketplace.constants';
import ResponseType = Constants.ResponseType;

export interface IQuoteWizardQuestionResponse<T> {
    questionId: string;
    responseType: ResponseType;
    response: T;
}

export class QuoteWizardQuestionResponse<T> implements IQuoteWizardQuestionResponse<T> {
    public questionId: string;
    public response: T;
    public responseType: Constants.ResponseType;

    constructor(questionId: string, responseType: Constants.ResponseType) {
        this.questionId = questionId;
        this.responseType = responseType;
    }
}